module.exports = __webpack_public_path__ + "static/media/add_tags_icon.a48bdfe8.svg";